import { useTranslation } from 'react-i18next'
import { CurecallInsertDropdown, type TTextareaVariableAddable } from '@honestica/curecall-ui'
import { EHumanReviewRequestProblem } from 'src/pages/dashboard/_components/human-review-requests.type'
import { useProblemLabels } from 'src/pages/dashboard/_components/use-problem-labels'

const CONVOCATION_PROBLEMS = [
  EHumanReviewRequestProblem.APPOINTMENT_CANCELLED,
  EHumanReviewRequestProblem.APPOINTMENT_RESCHEDULE_REQUESTED,
  EHumanReviewRequestProblem.MISSING_DISCHARGE_COMPANION,
  EHumanReviewRequestProblem.UNKNOWN,
] as const

type ConvocationProblemDropdownProps = {
  onSelect: (problem: EHumanReviewRequestProblem) => void
}

export function ConvocationProblemDropdown({ onSelect }: ConvocationProblemDropdownProps) {
  const { t } = useTranslation()
  const problemLabels = useProblemLabels()

  // CurecallInsertDropdown only accepts variable-shaped items: apiVariableSyntax carries the problem
  const dropdownItems: TTextareaVariableAddable[] = CONVOCATION_PROBLEMS.map((problem) => ({
    label:
      problem === EHumanReviewRequestProblem.UNKNOWN
        ? t('pages.configuration.followups.chatbot.conditional-sections.dashboard-problem-no-detail')
        : problemLabels[problem],
    apiVariableSyntax: problem,
    isReadOnly: false as const,
    example: { average: problem },
  }))

  const handleClickItem = (variable: TTextareaVariableAddable) => {
    const problem = CONVOCATION_PROBLEMS.find(
      (convocationProblem) => convocationProblem === variable.apiVariableSyntax,
    )
    if (problem) onSelect(problem)
  }

  return (
    <CurecallInsertDropdown
      onClickItem={handleClickItem}
      dropdownVariable={{
        label: t('pages.configuration.followups.chatbot.conditional-sections.add-dashboard'),
        items: dropdownItems,
        defaultVariable: dropdownItems[0],
      }}
    />
  )
}
